// extracted by mini-css-extract-plugin
export var listPeople = "ListPeople-module--list-people--3d9r_";
export var listPeopleHeader = "ListPeople-module--list-people-header--2sLK2";
export var listPeopleForm = "ListPeople-module--list-people-form--2Rd23";
export var paginationWrapper = "ListPeople-module--pagination-wrapper--29ffK";
export var displayOptions = "ListPeople-module--display-options--248_y";
export var displayLabels = "ListPeople-module--display-labels--71ssH";
export var displayLabelActive = "ListPeople-module--display-label-active--1VRwH";